import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentModel, EnvironmentsUpdate } from 'src/app/models/api/governance/environment.model';
import { HttpService } from '../../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentsHttpService {
  public readonly defaultPageSize: number = 50;

  /**
   * The environments base url
   * @private
   * @readonly
   */
  private readonly _baseUrl: string = 'governance/policies/integration';

  constructor(private readonly _httpService: HttpService) {}

  /**
   * Get all environments
   * @returns A collection of EnvironmentModel
   */
  public getEnvironments(integrationId: string): Observable<EnvironmentModel[]> {
    const url = `${this._baseUrl}/${integrationId}/environments`;
    return this._httpService.get<EnvironmentModel[]>(url);
  }

  public updateEnvironments(
    integrationId: string,
    policyId: string,
    environmentsToUpdate: EnvironmentsUpdate
  ): Observable<string> {
    const url = `${this._baseUrl}/${integrationId}/policy/${policyId}/environments`;
    return this._httpService.post<EnvironmentsUpdate, string>(url, environmentsToUpdate);
  }
}
